module.exports = __webpack_public_path__ + "img/red-hat-profile2.07951925.jpg";